const config = {
	apiUrl:
		process.env.REACT_APP_API_BACKEND_BASE_URL || 'http://default.api.url',
};

export default config;
